import * as React from "react";

import { Typography } from "@material-ui/core";
import { PortalAppBar } from "src/components/app-bar";
import { Footer } from "src/components/footer";
// import { SignupForm } from "src/components/signup-form";
import { LoginForm } from ".";
// import portalLogoL from "src/resources/themedportal-logo-large.png";
// import portalIconLW from "src/resources/themedportal-icon-large-white.png";
import portalIconS from "src/resources/themedportal-icon-small.png";
import { config } from 'src/config';

export class Login extends React.Component<any> {
  public render() {
    return (
      <div>
        <PortalAppBar />
        <div className="login">
          <div className="login__container">
            <div className="hero">
              <div className="hero__left">
                <div className="motto">
                  <Typography variant="h2" color="inherit">
                    Simplified solutions for the healthcare industry
                  </Typography>
                </div>
                <div className="mission">
                  <Typography variant="h5" color="inherit">
                    Our mission is to provide a platform to bring technology
                    solutions to the healthcare industry which provide
                    improvements in productivity, revenue generation, company
                    culture, employee relations, and patient care.
                  </Typography>
                </div>
              </div>
              <div className="hero__right">
                <LoginForm />
              </div>
            </div>
            <div className="sidekick">
              <div className="sidekick__logo">
                <img className="sidekick__logo--logo" src={portalIconS} />
              </div>
              <div className="philosophy">
                <Typography variant="subtitle1" paragraph={true}>
                  While individual technological solutions have advanced
                  significantly to improve patient care over the years, software
                  solutions for everyday business operations within healthcare
                  facilities have not kept pace. The medportal’s core value is
                  to increase the quality of life for healthcare professionals
                  and patients alike. We offer a software platform which
                  provides a single source solution for providers and owners
                  regardless of medical specialty or discipline. By automating
                  processes that consume precious time each day, healthcare
                  professionals will be freed from administrative tasks,
                  enabling more time to be focused on improving patient outcomes
                  and quality of life.
                </Typography>
              </div>
            </div>
          </div>
          <Footer />
        </div>
        <div style={{ position: 'absolute', right: 0, bottom: 0, display: 'none' }}>
          <iframe
            id="portal-frame"
            className="portal-frame"
            frameBorder="0"
            src={config.BASE_CHAT_URL + '/logout'}
            // width={'500px'}
            // height={'500px'}
            width={'100%'}
            height={'100%'}
          />
          <iframe
            id="portal-frame2"
            className="portal-frame2"
            frameBorder="0"
            src={config.BASE_CHAT_URL}
            // width={'500px'}
            // height={'500px'}
            width={'100%'}
            height={'100%'}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/Login.tsx